<template>
  <a
    href="javascript:void(0);"
    class="form__submit button"
    :class="classes"
    :data-acc="acc.toLowerCase()"
    :disabled="disabled"

    @click="onClick">

    <spinner :contained="true" v-if="isLoading" />

      <span  class="button__label">
        {{ L.localize(label) }}
      </span>
  </a>
</template>

<script>
import { Spinner } from 'components/partials'
import L from 'services/Localization'

export default {
  name: 'btn',
  components: { Spinner },
  props: {
    label: String,
    withBorder: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    float: {
      type: String,
      default: ''
    },
    acc: {
      type: String,
      required: false,
      default: ''
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      L: L
    }
  },
  computed: {
    classes() {
      return [
        { 'button--border': this.withBorder },
        { 'button--right': this.float === 'right' },
        { 'button--left': this.float === 'left' },
        { 'button--disabled': this.disabled }
      ]
    }
  },
  methods: {
    onClick() {
      if (!this.disabled) {
        this.$emit('click')
      }
    }
  }
}
</script >



// WEBPACK FOOTER //
// Btn.vue?8a80bf94